import {Profile, User} from '../../models';
import {profiles, users} from '../mockDB';
import {API} from '../types';

interface Params {
  email: string;
  password: string;
}

interface Response {
  token: string;
  refreshToken: string;
  profile: Profile;
  user: User;
}

export function authRegisterAPI(params: Params): API<Response> {
  return {
    getData: async client => {
      const {data} = await client({
        url: '/auth/register',
        method: 'POST',
        data: params,
      });
      return {data: data};
    },
    getMockData: () => {
      if (params.password == 'asd') {
        const user = users.find(u => u.identifier == params.email)!;
        const profile = profiles.find(u => u.email == params.email)!;
        return {
          token: 'qweASD123',
          refreshToken: 'qweASD123',
          profile: {...profile, user},
          user,
        };
      }
      throw 'Wrong username or password';
    },
  };
}
